<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/13EkZ6D/images/Cover.jpg?1694391860171" alt="This image is the cover for the book Specs"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Specs
      </h1>
      <p class="bookDescription body article font2">
        <p>Small town. Ohio, 1986. All Kenny and Ted want is to not feel like outcasts. What happens when a pair of X-ray glasses mysteriously appear? The magic specs open a world of possibilities for these misfit teens through the granting of literal wishes! Things start out innocent, but when they wish that their bully would disappear, things take a cursed turn, with far darker consequences than they thought possible… In this mysterious and nostalgic tale from writer David M. Booher (Canto, All-New Firefly) and artist Chris Shehan (House of Slaughter), Kenny and Ted realize they’ve received much more than they bargained for… Collects Specs #1-4.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        David M. Booher, Chris Shehan
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      BOOM! Studios
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4de3ebe8